import{ React, useState, useEffect, LoaderOverlay, withAuth, toast,connect, useDispatch, useSelector,useNavigate, MESSAGES } from './../../common/helper/common-imports.component.js';
import { initialFormData, initialErrors, fieldValidation, createMerchantData  } from '../../common/helper/form-constants.js';
import CryptoService from "../../../services/crypto-service.js";
import { FormField, SelectField } from './../../common/helper/formFields';

const BuySell = () => {
  const [activeTab, setActiveTab] = useState('per_details');
  const [activeTabType, setActiveTabType] = useState('ERC');
  const [formData, setFormData] = useState({
    quantity:''
   });
  const [errors, setErrors] = useState({ ...initialErrors });
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const [imageUrlTRC, setImageUrlTRC] = useState('');
  const [sellImageUrl, setSellImageUrl] = useState('');
  const [exchange, setExchange] = useState('ERC');
  const [crypto, setCrypto] = useState();
  const [options, setOptions] = useState([]);
 const [formDataBuy, setFormDataBuy] = useState([]);
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState([]);
  const [imagePreviews, setImagePreviews] = useState({});
const [sellImageRequest,setSellImageRequest] =  useState();
 
  const toggleDropdown = () => {
      setIsOpen(!isOpen);
  };

  const selectOption = (option) => {
      setSelectedOption(option);
      setIsOpen(false);
  };
  const getCryptoList = (e) => {
    setLoading(true);
    CryptoService.getCryptoList()
      .then(response => {
        let data = response.data.data;
        let optionsRecord = []
        for(var i =0; i<data.length; i++) {
          optionsRecord.push({
             value: data[i].id, label:  data[i].crypto_code, image: '/assets/usdt.png',details:data[i].details, min_quantity: data[i].min_quantity,max_quantity: data[i].max_quantity
          })
        }
        setOptions(optionsRecord)
        setCrypto(data)
        setSelectedOption(optionsRecord[0]);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
        console.error("Error fetching agents:", error);
      });
   
  }
  useEffect(() => {
   
    getCryptoList();
    document.body.style.backgroundImage = '';

    document.body.style.backgroundColor = '#f0f6fa';
        return () => {
          document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
        };
  }, []);

 
  const validateFields = (fields, formData) => {
    let isValid = true;
    fields.forEach(fieldName => {
      const fieldValue = formData[fieldName];
      if (!fieldValue || !fieldValue.trim()) {
        validateField(fieldName, fieldValue || ''); 
        isValid = false;
      }
    });
    
    return isValid;
  };
;

  
  const buyCurrency = (e) => {

    e.preventDefault();
    let requiredFields = ['quantity'];
    const data = new FormData();
    let imgArr = {};
    Object.keys(imageUrl).forEach(index => {
      console.log(imageUrl[index].exchange)
      if(imageUrl[index].exchange == 'ERC') {
        data.append('ercFile',imageUrl[index].file);
        imgArr['ercFile'] = imageUrl[index].file.name;
      }
      if(imageUrl[index].exchange == 'TRC') {
        data.append('trcFile',imageUrl[index].file);
        imgArr['trcFile'] = imageUrl[index].file.name;
      }
      
    });
    let address = [];
    for(var j=0; j<formDataBuy.length; j++) {
      if(formDataBuy[j].type == 'ERC') {
        data.append('ercAddress',formDataBuy[j].value);
      }
      if(formDataBuy[j].type == 'TRC') {
        data.append('trcAddress',formDataBuy[j].value);
      }
      address.push({ercAddress:formDataBuy[j].value,trcAddress:formDataBuy[j].value})
    }
    const finalImgArr = []
    if(imgArr.ercFile || imgArr.trcFile) {
      finalImgArr.push({
        ercFile:imgArr.ercFile,
        trcFile:imgArr.trcFile
      })
    }
   
    
    data.append('cryptoId',selectedOption.value);
    data.append('quantity',formData.quantity);
   
   
    e.preventDefault();
    let hasErrors;
    Object.keys(formData).forEach(fieldName => {
      const error = validateField(fieldName, formData[fieldName]);
      if (error) {
          hasErrors = true;
      }
  });
   
    if (isAllValuesBlank(formDataBuy) && (finalImgArr.length ==0)) {
      toast.error('Please add address or upload qr image.')
      return;
      // let fieldError =  validateField('transactionID','');
      // if(fieldError) {
      //   return;
      // }
    } 
    // if(imgArr.length == 0) {
    //   toast.error('Please upload QR image.');
    //   return
    // }
    if(address.length > 0) {
      if(address[0].ercAddress) {
        // if(!finalImgArr[0].ercFile) {
        //   toast.error('Please upload ERC QR image.');
        //    return
        // }
      }
      if(address[0].trcAddress) {
        // if(!finalImgArr[0].trcFile) {
        //   toast.error('Please upload TRC QR image.');
        //    return
        // }
      }
    }
    if(!hasErrors) {
      setLoading(true);
      CryptoService.createCryptoRequest(data,'buy')
        .then(response => {
          toast.success(MESSAGES.CRYPTO_BUY);
          navigate('/crypto-list')
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
          try {
            const errorMessage = error.response.data
            toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
          } catch (e){
            toast.error( MESSAGES.SERVER_ERROR)
          }
        });
    }
     
  }
  const isAllValuesBlank = (array) => {
    return array.every(item => item.value === '');
  };
  const sellCurrency = (e)=> {
    e.preventDefault();
    let requiredFields = ['quantity'];
    const data = new FormData();
   
    Object.keys(imageUrl).forEach(index => {
      data.append('screenshot',imageUrl[index].file);
      
    });
    
    for(var j=0; j<formDataBuy.length; j++) {

      data.append('transactionId',formDataBuy[j].value);
      data.append('exchange',formDataBuy[j].type);
      // let fieldError =  validateField('transactionID',formDataBuy[j].value);
      // if(fieldError) {
      //   return;
      // }
    }
    data.append('cryptoId',selectedOption.value);
    data.append('quantity',formData.quantity);

    if (!validateFields(requiredFields, formData)) {
      return
    } 
     if(imageUrl.length == 0 && formDataBuy.length == 0) {
       toast.error('Please upload payment proof or transaction id.')
       return;
     }
      setLoading(true);
      CryptoService.createCryptoRequest(data,'sell')
        .then(response => {
          toast.success(MESSAGES.CRYPTO_SELL);
          navigate('/crypto-list')
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
          try {
            const errorMessage = error.response.data
            toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
          } catch (e){
            toast.error( MESSAGES.SERVER_ERROR)
          }
        });
  }
  const handleChangeBuySell = (index, e, exchange) => {
    const newFormData = [...formDataBuy];
    if (!newFormData[index]) {
      newFormData[index] = {};
    }
    newFormData[index] = {value:e.target.value, type:exchange};
    setFormDataBuy(newFormData);
    validateField('transactionID',e.target.value)
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validateField(name, value);
   
  };
  const validateField = (fieldName, value) => {
    let min = selectedOption.min_quantity;
    let max = selectedOption.max_quantity
    if(fieldName == 'quantity') {
      if(value <min || value>max) {
        const errorMessage = `Please enter value between ${min} and ${max}`;
        setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
        return errorMessage
      }
    }
    const errorMessage = fieldValidation(fieldName, value);
    setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: errorMessage }));
    return errorMessage
  };
  const setTab = (tab) => {
    setErrors({
        quantity:'',
        transactionID:''
    })
    setFormData({
          quantity:'',
        transactionID:''
    })
    
    setImagePreviews({});
    setImageUrl([])
    setFormData([])
    setExchange('ERC')
    setActiveTabType('ERC')
    setActiveTab(tab);
  };
  const setTabType = (tab) => {
    if(tab =='ERC') {
        setExchange('ERC')
    } else {
        setExchange('TRC')
    }
    
    setActiveTabType(tab);
  };
  const handleFileChange  = (index,e,exchange) => {
    const file = event.target.files[0];
    const maxSize = 2 * 1024 * 1024; // 2 MB

    if (!file.type || !file.type.startsWith('image/')) {
      toast.error('Please select an image file.');
      return;
    }

    if (file && file.size <= maxSize) {
      const file = e.target.files[0];
      const newImageFiles = { ...imageUrl };
      const newImagePreviews = { ...imagePreviews };
  
      newImageFiles[index] = {file:file,exchange:exchange};
      newImagePreviews[index] = URL.createObjectURL(file);
  
      setImageUrl(newImageFiles);
      setImagePreviews(newImagePreviews);
      
    } else {
      setImageUrl('');
      toast.error('File size exceeds 2 MB. Please select a smaller file.');
    }

  }


  const handleDownload = (image) => {
    const link = document.createElement('a');
    link.href = image
    link.download = 'qrimage.png';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
const handleCopy = (textToCopy) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(textToCopy)
      .then(() => {
        toast.success(MESSAGES.TXT_COPIED);
      })
      .catch(err => {
        console.error('Failed to copy:', err);
        toast.error(MESSAGES.TXT_CPY_FAILED);
      });
  } else {
    // Fallback for unsupported browsers
    const textArea = document.createElement('textarea');
    textArea.value = textToCopy;
    textArea.style.position = 'fixed';  // Prevent scrolling to bottom of page in MS Edge.
    textArea.style.opacity = '0';       // Make the textarea invisible

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand('copy');
      document.body.removeChild(textArea);
      toast.success(MESSAGES.TXT_COPIED);
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
      toast.error(MESSAGES.TXT_CPY_FAILED);
      document.body.removeChild(textArea);
    }
  }
};
  return (
    <div>
    <LoaderOverlay loading={loading} />
    <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
    <h4 style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Crypto Buy/Sell</h4>
      <div className="container-fluid ghty" style={{backgroundColor: 'white'}}>
       
          <ul className="nav nav-tabs" style={{'cursor':'pointer'}}>
            <li className="nav-item tbbtrn" onClick={() => setTab('per_details')}>
              <a className={`nav-link ${activeTab==='per_details' ? 'active_tab1' : '' }`} id="list_per_details">BUY</a>
            </li>
            <li className="nav-item tbbtrn" onClick={() => setTab('address_details')}>
              <a className={`nav-link ${activeTab==='address_details' ? 'active_tab1' : '' }`} id="list_address_details">SELL</a>
            </li>
          </ul>
          <div className="tab-content" style={{marginTop: '16px'}}>
          <form method="post" id="register_form" action="#" className="tab-content"  onSubmit={buyCurrency}>
            <>
            <div className={`tab-pane ${activeTab==='per_details' ? 'active' : 'fade' }`} id="per_details">
              <div className="panel panel-default">
                <div className="panel-body" style={{padding: '0px'}}>
                  <div className="container col-md-12" style={{padding: 0, width:'100%'}}>
                  <div style={{width:'100%',float:'left'}} className='frm'>
                    <div className="col-md-4 crypto" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="custom-dropdown" style={{ marginTop: errors.quantity ? '-10px' : '11px' }}>
                        <div className="selected-option" onClick={toggleDropdown}>
                            {selectedOption ? (
                                <div className="selected">
                                    <img src={selectedOption.image} width={'23px'} alt={selectedOption.label} className="dropdown-image" />
                                   <span> {selectedOption.label}</span>
                                </div>
                            ) : (
                                <div className="placeholder">Select an option</div>
                            )}
                            <div className={`arrow ${isOpen ? 'open' : ''}`}></div>
                        </div>
                        {/* {isOpen && (
                            <div className="options">
                                {options.map((option) => (
                                    <div key={option.value} className="option" onClick={() => selectOption(option)}>
                                        <img src={option.image} width={'10px'} alt={option.label} className="dropdown-image" />
                                       <span>{option.label}</span> 
                                    </div>
                                ))}
                            </div>
                        )} */}
                    </div>

                      <div className="form-group frm" style={{textAlign: 'left'}}>
                     
                        <FormField type="text" isRequierd={false} id="f_name" name="quantity"  placeholder="Enter Quantity" onChange={handleChange} error={errors.quantity} maxlength={100} margin={"0"}/>
                      </div>
                    </div>
                    </div>
                    <div style={{width:'100%',float:'left'}} className='frm'>
                   
                      
                      <ul className="nav nav-tabs"  style={{'cursor':'pointer'}}>
                      {selectedOption && selectedOption.details && selectedOption.details.map((option, index) => ( 
                        <li className="nav-item tbbtrn"  key={option.exchange} onClick={() => setTabType(option.exchange)}>
                          <a className={`nav-link ${activeTabType===option.exchange ? 'active_tab1' : '' }`} id={option.exchange}>{option.exchange}</a>
                        </li>
                      ))}
                      </ul>
                      
                    </div>
                   
                <div className='tab-content'>
                {selectedOption && selectedOption.details && selectedOption.details.map((option, index) => ( 
                    <div  className={`frm tab-pane ${activeTabType===option.exchange  ? 'active' : 'fade' }`}>
                    <div className="col-md-12" style={{padding: '0px', paddingRight: '30px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <FormField type="text" isRequierd={true} id="f_name" name="transactionID" label={`${option.exchange} Address ID`} placeholder={`${option.exchange}  Address ID`} onChange={(e) => handleChangeBuySell(index, e,option.exchange)} error={errors.transactionID} maxlength={100} width={'250px'}/>
                      </div>
                      </div>
                      <div className="col-md-12" style={{padding: '0px', paddingRight: '30px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label className='required'>{option.exchange} Upload QR</label>
                        <br></br>
                        <input style={{width: '250px', display: 'inline'}} type="file" className="form-control" accept="image/*" id="imageInput"  onChange={(e) => handleFileChange(index, e,option.exchange)} name="f_name" />
                        {imagePreviews[index] && (
                  <img src={imagePreviews[index]} alt="Preview" className="image-preview vjk" />
                )}
                      </div>
                      </div>
                      </div>
                ))}
                      
                      </div>
                  </div>
                  <br />
                  <div align="left">
                    <button type="submit" name="btn_login_details" id="btn_login_details" className="btn ddfg" style={{marginTop:'16px'}} >Submit</button>
                  </div>
                  <br />
                </div>
              </div>
            </div>
            </>
            </form>
            
            <form onSubmit={sellCurrency}  className='tab-content'>
            {/* Sell Starts here */}
            <div className={`tab-pane ${activeTab==='address_details' ? 'active' : 'fade' }`} id="per_details">
              <div className="panel panel-default">
                <div className="panel-body" style={{padding: '0px'}}>
                  <div className="container col-md-12" style={{padding: 0, width:'100%'}}>
                  <div style={{width:'100%',float:'left'}} className='frm'>
                    <div className="col-md-4 crypto" style={{padding: '0px', paddingRight: '30px'}}>
                    <div className="custom-dropdown"  style={{ marginTop: errors.quantity ? '-10px' : '11px' }}>
                        <div className="selected-option" onClick={toggleDropdown}>
                            {selectedOption ? (
                                <div className="selected">
                                    <img src={selectedOption.image} width={'23px'} alt={selectedOption.label} className="dropdown-image" />
                                   <span> {selectedOption.label}</span>
                                </div>
                            ) : (
                                <div className="placeholder">Select an option</div>
                            )}
                            <div className={`arrow ${isOpen ? 'open' : ''}`}></div>
                        </div>
                        {/* {isOpen && (
                            <div className="options">
                                {options.map((option) => (
                                    <div key={option.value} className="option" onClick={() => selectOption(option)}>
                                        <img src={option.image} width={'10px'} alt={option.label} className="dropdown-image" />
                                       <span>{option.label}</span> 
                                    </div>
                                ))}
                            </div>
                        )} */}
                    </div>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <FormField type="number" margin={'0'} isRequierd={false} id="f_name" name="quantity"  placeholder="Enter Quantity" onChange={handleChange} error={errors.quantity} maxlength={100} />
                      </div>
                    </div>
                    </div>
                    <div style={{width:'100%',float:'left'}} className='frm'>
                      <ul className="nav nav-tabs"  style={{'cursor':'pointer'}}>
                      {selectedOption && selectedOption.details && selectedOption.details.map((option, index) => ( 
                        <li className="nav-item tbbtrn"  key={option.exchange} onClick={() => setTabType(option.exchange)}>
                          <a className={`nav-link ${activeTabType===option.exchange ? 'active_tab1' : '' }`} id={option.exchange}>{option.exchange}</a>
                        </li>
                      ))}
                      </ul>
                      
                    </div>
                    {selectedOption && selectedOption.details && selectedOption.details.map((option, index) => ( 
                      <>
                      <div class="tab-content">
                    <div  className={`frm tab-pane  ${activeTabType===option.exchange ? 'active' : 'fade' }`}>
                        <div className='col-md-2'>
                          <img style={{width:'136px', paddingTop:'12px'}} src={option.qr_url}></img>
                        <p  onClick={() => handleDownload(option.qr_url)} style={{'textAlign':'center', 'paddingRight':'40px', 'cursor':'pointer'}}>  <i class="fa fa-download"  style={{color:'black', cursor:'pointer'}}></i> Download</p>
                        </div>
                        <div className='col-md-8' style={{paddingTop:'10px'}}>
                          <label>Key</label>
                          <p>{option.address} <i class="fa fa-copy" onClick={() => handleCopy(option.address)}  style={{color:'black', cursor:'pointer'}}></i></p>
                          <FormField type="text" isRequierd={false} id="f_name" name="fullName" label="Exchange" value={option.exchange} placeholder="Exchange"  onChange={handleChange} maxlength={100} width={'250px'} disabled={true}/>
                        </div>
                      </div>
                      </div>
                    
                    <div className='tab-content'>
                    <div style={{width:'100%',float:'left'}} className={`frm tab-pane  ${activeTabType===option.exchange ? 'active' : 'fade' }`} >
                    <ul className="nav nav-tabs" >
                        <li className="nav-item tbbtrn">
                          <a className='nav-link active_tab1' id="ERC">Payment Confirmation</a>
                        </li>
                        
                      </ul>
                      <div className="col-md-12" style={{padding: '0px', paddingRight: '30px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <FormField type="text" isRequierd={true} id="f_name" name="transactionID" label={`${option.exchange} Transaction ID`} placeholder={`${option.exchange}  Transaction ID`} value={formData.transactionID} onChange={(e) => handleChangeBuySell(index, e,option.exchange)} error={errors.transactionID} maxlength={100} width={'250px'}/>
                      </div>
                      </div>
                      <div className="col-md-12" style={{padding: '0px', paddingRight: '30px'}}>
                      <div className="form-group frm" style={{textAlign: 'left'}}>
                        <label>{option.exchange} Upload Payment Proof</label>
                        <br></br>
                        <input style={{width: '250px', display: 'inline'}} type="file" className="form-control" accept="image/*" id="imageInput" name="f_name" onChange={(e) => handleFileChange(index, e)}/>
                        {imagePreviews[index] && (
                  <img src={imagePreviews[index]} alt="Preview" className="image-preview vjk" />
                )}
                      </div>
                      </div>
                    </div>
                    </div>
                    </>
                    ))}
                  </div>
                  <br />
                  <div align="left">
                    <button type="submit" name="btn_login_details" id="btn_login_details" className="btn ddfg" >Submit</button>
                  </div>
                  <br />
                </div>
              </div>
            </div>
            </form>
          </div>
      
      </div>
    </div>
  </div>
  );


  }

export default withAuth(BuySell);
